import i18n from "../../../../../constants/i18n"
import ET3Circle from "../../../../../core/et3-circle"
import ET3Div from "../../../../../core/et3-div"
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render"
import Et3Text from "../../../../../core/et3-text"
import Et3Margin from "../../../../../core/et3-ui/ET3Margin"

export const ExcludeSearch = withLiteObserverAndTheme<{
    onClick: () => void;
    state: boolean;
    isDisabled: boolean
}>((props) => {
    const { theme, onClick, state, isDisabled } = props
    const { colors } = theme

    return (
        <ET3Div
            width={100}
            height={100}
            alignItems={"center"}
            fDirection={"column"}
            style={{}}
            color={""}
            justifyContent={"center"}
            withShadow={false}
            isExtendable={false}
            isScrollable={false}
            onClick={() => { }}
        >
            <ET3Circle
                size={20}
                style={{
                    border: `2px solid ${colors.all.dimGray}`,
                    backgroundColor: isDisabled ? colors.all.gray : state ? colors.all.green : colors.all.transparent,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer"
                }}
                color={""}
                withShadow={true}
                onClick={isDisabled ? null : onClick}
            />

            <Et3Margin top={5} bottom={0} left={0} right={0} />
            <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={25}
                isSpan={true}
                text={i18n.get("EXCLUDE")}
                style={{}}
                color={""}
            />
        </ET3Div>
    )
})

export default ExcludeSearch